import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { Outlet } from 'react-router-dom'
import { faDraftingCompass } from '@fortawesome/free-solid-svg-icons'
import { IncentiviRoute } from '@/routes/admin/autodesk/pages/Incentivi.route'
import { PercentualiRoute } from '@/routes/admin/autodesk/pages/Percentuali.route'
import { CommissioniRoute } from '@/routes/admin/autodesk/pages/Commissioni.route'

export const AutodeskRoute: TileRoleRoute = {
  path: 'autodesk',
  text: 'Autodesk',
  element: (
    <>
      <Outlet />
    </>
  ),
  faIcon: faDraftingCompass,
  handle: {
    crumb: () => ({
      label: 'Autodesk',
      icon: faDraftingCompass,
    }),
  },
  mainMenuRoute: false,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
  tile: true,
  children: [IncentiviRoute, PercentualiRoute, CommissioniRoute],
}
